import * as React from 'react'
import { Alert, Button, Spinner } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { passwordResetAPI } from 'api/password'
import { Status } from 'api/common/statuses'
import Footer from 'components/Footer'
import Header from 'components/Header'
import InputField from 'components/InputField'
import { scrollToAnchor } from 'utilities/helper'
import { passwordResetFormItems } from 'utilities/resources/formItems'
import { PasswordResetFormValues } from 'utilities/resources/formItemValues'
import { PropertySetter } from 'utilities/typeUtility'
import { ErrorChecker, FormErrorMessage, emailValidator } from 'utilities/validators'

const SceneComponent: React.FC = () => {
  const navigate = useNavigate()
  const [formValues, setFormValues] = React.useState<PasswordResetFormValues>({
    email: '',
  })
  const setter = new PropertySetter(setFormValues)
  const [information, setInformation] = React.useState('')
  const [enabled, setEnabled] = React.useState(false)
  const [committed, setCommitted] = React.useState(false)
  const [errorValues, setErrorValues] = React.useState<FormErrorMessage<PasswordResetFormValues>>()
  const errorChecker = new ErrorChecker<PasswordResetFormValues>(passwordResetFormItems)
  React.useEffect(() => {
    setEnabled(formValues.email.trim() !== '')
  }, [formValues.email])

  /**
   * 「メールを送信する」ボタン
   */
  const handleButton = () => {
    errorChecker.init()
    errorChecker.check(emailValidator(formValues.email), 'email')
    setErrorValues(errorChecker.getErrorMessageData())
    if (errorChecker.isValid()) {
      setCommitted(true)
      passwordResetAPI({ email: formValues.email }, (status) => {
        switch (status) {
          case Status.Success: {
            navigate('/emailSentComplete', { state: { email: formValues.email } })
            break
          }
          default: {
            setInformation('入力したメールアドレスの登録がありません。')
            break
          }
        }
        setCommitted(false)
      })
    } else {
      scrollToAnchor(errorChecker.getFirstInvalidItemId())
    }
  }
  return (
    <>
      <Header title="パスワード再設定" />
      <main>
        <section className="mx-4 my-5">
          <p className="mt-4">ご登録のメールアドレスを入力してください。</p>
          {information && (
            <Alert variant="danger" className="mt-5">
              {information}
            </Alert>
          )}
          <form className="mt-5">
            <InputField
              name={passwordResetFormItems.email.name}
              labelTop={passwordResetFormItems.email.label}
              type="email"
              bold
              placeholder="Emailアドレスを入れてください"
              ariaLabel="Enter email address"
              onChange={(e) => setter.set('email', e)}
              errors={[errorValues?.email ?? '']}
            />
            <div className="mt-5">
              <Button variant="primary" className="w-100 py-4" onClick={handleButton} disabled={!(enabled && !committed)}>
                <Spinner className="me-2" as="span" animation="border" size="sm" role="status" aria-hidden="true" hidden={!committed} />
                メールを送信する
              </Button>
            </div>
          </form>
          <div className="mt-5 text-center">
            <Button variant="link" href="/login">
              戻る
            </Button>
          </div>
        </section>
      </main>
      <Footer className="mt-5" />
    </>
  )
}

export default SceneComponent
